<template>
  <div class="selectable-table-container" @keydown="handleKeyDown" tabindex="0">
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Revision</th>
          <th>TD</th>
        </tr>
        <tr>
          <th>
            <input 
              ref="searchbox"  
              v-model="searchModel.userFK_Revision_AcctMstr"
              @keydown.down="handleArrowDown" 
              @keydown.enter="onSubmit"  
              class="form-control"
            />
          </th>
          <th>
            <input v-model="searchModel.userPK_ARP_AcctMstr" 
            @keydown.down="handleArrowDown" 
            @keydown.enter="onSubmit"  
            class="form-control"/> 
            <button class="d-lg-none btn btn-sm"></button>
          </th>
        </tr>
      </thead>
      <tbody 
        ref="tbodyRef" 
        @keydown="handleKeyDown" 
        tabindex="0"
        @focus="isFocused = true"
        @blur="isFocused = false"
      >
        <tr
         v-show="!isProcessing"
          v-for="(item, index) in rpus"
          :key="item.sysPK_AcctMstr || index"
          :class="{ 
            'active-row': activeIndex === index,
            'focused-row': isFocused && activeIndex === index
          }"
          @click="selectItem(item)"
          @dblclick="emitSelected(item)"
        >
          <td>{{item.userFK_Revision_AcctMstr}}</td>
          <td>{{item.userPK_ARP_AcctMstr}}</td>
        </tr>
        <tr v-if="isProcessing">
            <td colspan="6">
                <SpinnerBlock/>
            </td>
        </tr>
         <tr v-if="!isProcessing &&(!rpus || rpus.length === 0)">
            <td class="text-center" colspan="6">
                No records found.
            </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import acctMasterService from '@/services/acctMasterService';
import SpinnerBlock from '@/components/animations/SpinnerBlock.vue';
// eslint-disable-next-line
defineExpose({focusInput})
// eslint-disable-next-line
const emit = defineEmits(['item-selected'])
const activeIndex = ref(-1)
const tableContainer = ref(null)
const searchbox = ref(null)
const tbodyRef = ref(null)
const isFocused = ref(false)
const rpus = ref();
const isProcessing = ref(false);
const searchModel = ref({
    userFK_Revision_AcctMstr: 'R13',
    userPK_ARP_AcctMstr: ''
});
const onSubmit = () => {
  searchRPU();
}

const searchRPU = async()=>{
    activeIndex.value = -1;
    isProcessing.value = true;
    rpus.value = await acctMasterService.searchRPU(searchModel.value);
    isProcessing.value = false;
}


const handleArrowDown = (e) => {
  e.preventDefault()
  tbodyRef.value?.focus()
  activeIndex.value = -1; // Start with first row when coming from search
}

const handleKeyDown = (e) => {
  if (!['ArrowDown', 'ArrowUp', 'Enter', 'Home', 'End'].includes(e.key)) return
  
  e.preventDefault()
  
  switch(e.key) {
    case 'ArrowDown':
      moveSelection(1)
      break
    case 'ArrowUp':
      moveSelection(-1)
      break
    case 'Enter':
      confirmSelection()
      break
    case 'Home':
      activeIndex.value = 0
      break
    case 'End':
      activeIndex.value = rpus.value.length - 1
      break
  }
}
// eslint-disable-next-line
function focusInput() {
  setTimeout(() => {
    searchbox.value?.focus()
  }, 150)
}

const scrollToRow = (index) => {
  const rows = tbodyRef.value?.querySelectorAll('tr')
  if (rows && rows[index]) {
    rows[index].scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    })
  }
}
const isMoving = ref(false);
const moveSelection = (direction) => {
    if(isMoving.value)
    return;
  const newIndex = activeIndex.value + direction
  if (newIndex >= 0 && newIndex < rpus.value.length) {
  isMoving.value = true;
    activeIndex.value = newIndex
    scrollToRow(activeIndex.value);
    setTimeout(()=>{
        isMoving.value = false;
    },100);
  }
}
const isEmitting=ref(false);
// Only emit happens here now
const confirmSelection = () => {
    if(!isFocused.value)
    return;
  if(isEmitting.value)
  return;
  if (activeIndex.value >= 0) {
    isEmitting.value = true;
    emit('item-selected', rpus.value[activeIndex.value])
    setTimeout(()=>{
        isEmitting.value = false;
    },300);
  }
}

const selectItem = (item) => {
  const index = rpus.value.findIndex(i => i === item)
  if (index !== -1) {
    activeIndex.value = index
  }
}

const emitSelected = (item) => {
  emit('item-selected', item)
}

const handleClickOutside = (e) => {
  if (tableContainer.value && !tableContainer.value.contains(e.target)) {
    tableContainer.value.blur()
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
  tableContainer.value = document.querySelector('.selectable-table-container')
  searchRPU();
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped>
tr.active-row>td {
  background-color: #dc3545 !important;
  color: white;
}

.selectable-table-container {
  max-height: 400px;
  overflow-y: auto;
  outline: none;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table tbody tr {
  cursor: pointer;
  transition: background-color 0.2s;
}

.table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.table tbody tr.focused-row {
  box-shadow: inset 0 0 0 2px #3b82f6;
}

.table th,
.table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #dee2e6;
}

.table th {
  background-color: #f8f9fa;
  font-weight: 600;
  position: sticky;
  top: 0;
}
</style>